"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Field = void 0;
var Errors_1 = require("../utils/Errors");
var constants_1 = require("./constants");
var Field = /** @class */ (function () {
    function Field() {
    }
    /**
     * @example Field.parse('000201'); // { id: '00', size: 2, data: '01' }
     * @param id ID from this field
     * @param data Data from this field
     * @returns Parsed field
     */
    Field.prototype.parseOne = function (field) {
        var id = field.substring(0, 2);
        var size = field.substring(2, 4);
        if (!Object.values(constants_1.IDS).includes(id)) {
            throw new Errors_1.PIXError("this id<" + id + "> is invalid");
        }
        var config = constants_1.FIELD_CONFIG.find(function (fieldConfig) { return fieldConfig.id === id; });
        var data = field.substring(4, 4 + Number(size));
        if (config && config.hasBody)
            data = this.parse(data);
        var rest = field.replace(field.substring(0, 4 + Number(size)), '');
        if (rest === '')
            rest = null;
        return {
            id: id,
            size: Number(size),
            data: data,
            rest: rest
        };
    };
    Field.prototype.parse = function (field) {
        var fields = [];
        var payloadRest = field;
        while (typeof payloadRest === 'string' && payloadRest.length > 0) {
            var field_1 = this.parseOne(payloadRest);
            payloadRest = field_1.rest;
            fields.push({ id: field_1.id, data: field_1.data, size: field_1.size });
        }
        return fields;
    };
    /**
     * @example Field.stringify('00', '01'); // 000201 -> [00:ID][02:size][01:data]
     * @param id ID from this field
     * @param data Data from this field
     * @returns Stringified field
     */
    Field.prototype.stringify = function (id, data) {
        if (!Object.values(constants_1.IDS).includes(id)) {
            throw new Errors_1.PIXError('this id is invalid');
        }
        var size = String(data.length).padStart(2, '0');
        return "" + id + size + data;
    };
    return Field;
}());
var field = new Field();
exports.Field = field;
